// extracted by mini-css-extract-plugin
export var author = "section-header-module--author--1898b";
export var category = "section-header-module--category--ec1ba";
export var header = "section-header-module--header--cb687";
export var headline = "section-header-module--headline--29594";
export var headlinePost = "section-header-module--headline-post--39f75";
export var paragraph = "section-header-module--paragraph--d673f";
export var readMore = "section-header-module--read-more--6b2de";